import { render, staticRenderFns } from "./MosquitoBorneDieseasesRiskPredictions.vue?vue&type=template&id=2a860f5f"
import script from "./MosquitoBorneDieseasesRiskPredictions.vue?vue&type=script&lang=js"
export * from "./MosquitoBorneDieseasesRiskPredictions.vue?vue&type=script&lang=js"
import style0 from "./MosquitoBorneDieseasesRiskPredictions.vue?vue&type=style&index=0&id=2a860f5f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports